import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBUser = z.object({
  email: z.string().email().optional(),
  password: z.string(),
  name: z.string().optional(),
  phone: z.string().optional(),
  tenants: z.array(z.string()),
  tenantRoles: z.record(z.string(), z.array(z.string())).optional(),
  oauthProviders: z.record(z.string(), z.object({
    subject: z.string(),
    email: z.string().email().optional(),
    name: z.string().optional(),
    accessToken: z.string().optional(),
    refreshToken: z.string().optional(),
    idToken: z.string().optional(),
    scope: z.string().optional(),
    tokenType: z.string().optional(),
    expiresAt: z.date().optional(),
    rawUserInfo: z.unknown().optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
  })).optional(),
  emailVerificationCode: z.string().length(6).optional(),
  emailVerificationExpiresAt: z.date().optional(),
  passwordResetCode: z.string().length(6).optional(),
  passwordResetCodeExpiresAt: z.date().optional(),
  passwordResetToken: z.string().optional(),
  passwordResetTokenExpiresAt: z.date().optional(),
})

export type IRBUser = z.infer<typeof ZRBUser>;

export const RBUserSchema: Schema = new Schema({
  email: { type: String, unique: true, sparse: true },
  phone: { type: String, unique: true, sparse: true },
  password: { type: String, required: true },
  name: String,
  tenants: { type: [String], index: true, required: true },
  tenantRoles: { type: Map, of: [String], required: false, default: {} },
  oauthProviders: {
    type: Map,
    of: new Schema({
      subject: { type: String, required: true },
      email: { type: String, required: false },
      name: { type: String, required: false },
      accessToken: { type: String, required: false },
      refreshToken: { type: String, required: false },
      idToken: { type: String, required: false },
      scope: { type: String, required: false },
      tokenType: { type: String, required: false },
      expiresAt: { type: Date, required: false },
      rawUserInfo: { type: Schema.Types.Mixed, required: false },
      createdAt: { type: Date, required: false },
      updatedAt: { type: Date, required: false },
    }, { _id: false }),
    default: {},
    required: false,
  },
  emailVerificationCode: { type: String, required: false },
  emailVerificationExpiresAt: { type: Date, required: false },
  passwordResetCode: { type: String, required: false },
  passwordResetCodeExpiresAt: { type: Date, required: false },
  passwordResetToken: { type: String, required: false },
  passwordResetTokenExpiresAt: { type: Date, required: false },
})
